import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './auth/AuthContext'
import { ProtectedRoute } from './auth/ProtectedRoute'
import { Layout } from './components/Layout'
import { LoginPage } from './pages/LoginPage'
import { SchemaExplorer } from './pages/SchemaExplorer'
import { TableBrowser } from './pages/TableBrowser'
import { ViewSelector } from './components/ViewSelector'
import { MigrationsPage } from './pages/MigrationsPage'
import { PendingChangesPage } from './pages/PendingChangesPage'

function App() {
  const { isAuthenticated } = useAuth()

  return (
    <Routes>
      <Route path="/login" element={
        isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />
      } />

      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route path="/" element={<ViewSelector />} />
          <Route path="/tables/:tableName" element={<TableBrowser />} />
          <Route path="/schema" element={<SchemaExplorer />} />
          <Route path="/pending-changes" element={<PendingChangesPage />} />
          <Route path="/migrations" element={<MigrationsPage />} />
        </Route>
      </Route>
    </Routes>
  )
}

export default App
